module.exports = __webpack_public_path__ + "dixit.png?a8205955bd6ee215306d25fec20638e4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/dixit.png
// module id = 130
// module chunks = 0